import { Button, Grid, Menu, MenuItem, Stack, Typography } from '@mui/material';

import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { useState } from 'react';
import { PRESENTATION_STATE_UPDATE_TYPES } from '../consts';

const PresentationsBOMassiveSelectionStack = ({
    t,
    selectedPresentations,
    handleMassiveStateChangeClick,
    handleMassiveExportClick,
    isExportingSelection,
    showMassiveExport
}: any) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const menuOpen = Boolean(anchorEl);
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleStateChangeClickInternal = async (
        newState: keyof typeof PRESENTATION_STATE_UPDATE_TYPES
    ) => {
        handleCloseMenu();
        handleMassiveStateChangeClick(newState);
    };

    return (
        <Grid item>
            <Grid>
                <Stack direction="row" spacing={2} alignItems={'center'}>
                    <Typography>
                        {t('massiveActions.selectedPresentationsQuantity', {
                            count: selectedPresentations.length
                        })}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={handleOpenMenu}
                        sx={{ borderRadius: 1.2, pt: 1, pb: 1 }}
                        endIcon={menuOpen ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
                    >
                        {t('massiveActions.stateChange.title')}
                    </Button>
                    {showMassiveExport && (
                        <Button
                            variant="outlined"
                            onClick={handleMassiveExportClick}
                            disabled={isExportingSelection}
                            sx={{ borderRadius: 1.2, pt: 1, pb: 1 }}
                        >
                            Exportar seleccion
                        </Button>
                    )}
                </Stack>
            </Grid>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                sx={{ mt: 1 }}
            >
                <MenuItem
                    onClick={() => {
                        handleStateChangeClickInternal(PRESENTATION_STATE_UPDATE_TYPES.REVISE);
                    }}
                >
                    {t('states.en_revision')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleStateChangeClickInternal(PRESENTATION_STATE_UPDATE_TYPES.VISIT);
                    }}
                >
                    {t('states.pendiente_visita')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleStateChangeClickInternal(PRESENTATION_STATE_UPDATE_TYPES.SEEN);
                    }}
                >
                    {t('states.visado')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleStateChangeClickInternal(PRESENTATION_STATE_UPDATE_TYPES.CONFORM);
                    }}
                >
                    {t('states.presentado')}
                </MenuItem>
            </Menu>
        </Grid>
    );
};

export { PresentationsBOMassiveSelectionStack };
